import api from 'services/Api';
import {savaPushMessage} from '../../views/extera/pushStorage';

export async function postTicket({data, files}) {
  const formData = new FormData();
  formData.set('data', JSON.stringify(data));
  files && files.map((file, i) => formData.set(`file${i + 1}`, file));
  return await api.invoke('POST', '/support/v1/tickets', formData);
}
export async function fetchTicket(id) {
  const {
    data: {ticket},
  } = await api.invoke('GET', `/support/v1/tickets/${id}`);
  return ticket;
}
export async function fetchTicketsByFilter(offset, limit) {
  const {data} = await api.invoke('GET', '/support/v1/ticketsFilter', null, {
    params: {
      offset,
      limit,
    },
  });

  return data.tickets;
}
export async function closeTicket(id) {
  return await api.invoke('POST', `/support/v1/tickets/${id}/close`);
}
export async function fetchDepatments() {
  const {
    data: {departmentList},
  } = await api.invoke('GET', '/support/v1/departmentsList');
  return departmentList;
}
export async function postReplies({data, files}) {
  const formData = new FormData();
  formData.set('data', JSON.stringify(data));
  files && files.map((file, i) => formData.set(`file${i + 1}`, file));
  return await api.invoke('POST', '/support/v1/replies', formData);
}

export async function getAnnouncement(updater) {
  const {data} = await api.invoke('GET', '/support/v1/assignAnnouncement');
  savaPushMessage(data.announcements, updater);
  return data;
}

export async function postUnreadAnnouncement(ids) {
  const {data} = await api.invoke('POST', '/support/v1/user/announcement', {
    ids,
  });
  return data;
}
